import { Link } from 'gatsby'
import React from 'react'
import styled from 'styled-components'
import mediaQuery from 'styles/mediaQuery'

const NavigationContainerStyle = styled.nav`
  width: 100%;
  display: flex;
  margin-top: 32px;
  margin-bottom: 24px;
`

const NavigationStyle = styled.ul`
  width: 100%;
  display: flex;
  justify-content: center;
  gap: 24px;
  & > li {
    text-decoration-line: underline;
    & > a {
      color: #191919;
    }
  }
  ${mediaQuery.mobile} {
    & > li {
      font-size: 12px;
    }
  }
`

const translations = {
  termsLabel: 'Terms & Conditions',
  privacyLabel: 'Privacy policy',
}

const FooterNavigation = () => (
  <NavigationContainerStyle>
    <NavigationStyle>
      <li>
        <Link href="" title={translations.termsLabel}>
          {translations.termsLabel}
        </Link>
      </li>
      <li>
        <Link href="" title={translations.privacyLabel}>
          {translations.privacyLabel}
        </Link>
      </li>
    </NavigationStyle>
  </NavigationContainerStyle>
)

export default FooterNavigation
